import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard {
  constructor(
    private readonly router: Router,
    private readonly afAuth: AngularFireAuth,
  ) {}

  async canActivate(): Promise<boolean> {
    const currentUser = await this.afAuth.currentUser;
    if (currentUser) {
      return true;
    }

    await this.router.navigate(['/login']);
    return false;
  }
}
